"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "farini": {
    "dae7fdc3": [{
      "hkey": "cb2b62aa",
      "slug": "san-savino",
      "name": "San Savino",
      "primary": true,
      "skipSearch": false
    }],
    "cogno-san-savino": [{
      "hkey": "cb2b62aa",
      "slug": "san-savino",
      "name": "San Savino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d50ad4c9": [{
      "hkey": "6df7894b",
      "slug": "montereggio-poggiolo",
      "name": "Montereggio-Poggiolo",
      "primary": true,
      "skipSearch": false
    }],
    "montereggio": [{
      "hkey": "6df7894b",
      "slug": "montereggio-poggiolo",
      "name": "Montereggio-Poggiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;